import { QueryClient } from '@tanstack/react-query';

/** The app's one QueryClient — shared so sign-in/out can clear it (see lib/client-reset.ts). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false }
  }
});
